/*
 * @Description: 筛选有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  今天: 'Today',
  昨天: 'Yesterday',
  天: 'Day',
  自定义: 'Custom',
  本年度: 'This Year',
  上一年: 'Last Year',
  本季度: 'This Quarter',
  上一季度: 'Last Quarter',
  本月: 'This Month',
  上月: 'Last Month',
  本周: 'This Week',
  上周: 'Last Week',
  缺少参数: 'Missing Parameters',
  仅看我的: 'View Mine Only',
  部门: 'Department',
  用户: 'User',
  人员: 'Staff',
  组织机构: 'Organization',
  关闭搜索: 'Close Search',
  组织架构: 'Organizational Structure',
  智书企飞: 'Zhishu Qifei',
  输入关键字进行过滤: 'Enter Keywords to Filter',
  输入关键词进行查询: 'Enter keywords to search',
  请输入商机名称或客户名称: 'Please enter an opportunity name or customer name',
  请输入产品名称: 'Please enter a product name',
  请输入客户名称搜索报价单: 'Please enter the customer name to search for a quote',
  请输入客户名称搜索合同: 'Please enter the customer name to search for a contract',
  请输入客户名称搜索订单: 'Please enter the customer name to search for the order',
  加载中: 'Loading',
  负责人: 'Person in Charge',
  '暂无数据，请返回上级': 'No Data, Please Go Back to the Previous Level',
  参数为必传参数: 'Parameters are Required',
  '暂无搜索结果，请更换搜索关键字': 'No Search Results, Please Change the Keyword',
  已选: 'Selected',
  数: 'Amount',
  清空: 'Clear',
  请选择: 'Please Select ',
  请上传: 'Please upload',
  '暂无数据，请先选择': 'No Data, Please Select First',
  选择部门: 'Choose a Department',
  提示: 'Hint',
  确认重置: 'Confirm the reset',
  'App Secret重置后会导致历史用户信息失效，请务必二次确认是否继续进行重置操作！': 'The reset of APP SECRET will invalidate the history user information. Please double check whether you want to continue the reset operation!',
  你所选择的: 'Your Selection',
  包含下级: 'Include Subordinates',
  是否确认选择: 'Confirm Selection?',
  全部: 'All',
  我负责的: 'My Responsibility',
  我协作的: 'I Collaborated With',
  我团队负责的: "My Team's Responsibility",
  请输入: 'Please Enter ',
  我团队协作的: 'I work as a team',
  最多可选: 'The maximum number of options is '
};
